var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispatching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7012 20.0926L19.9144 19.3058C20.2513 18.6321 20.3643 17.9573 20.3643 17.2836C20.3643 16.3839 19.9144 15.4852 19.2407 14.9234C17.7792 13.463 15.4201 13.463 13.9586 14.9234C12.4982 16.3839 12.4982 18.7441 13.9586 20.2045C15.1952 21.4411 16.8806 21.666 18.341 20.8793L19.1277 21.666C19.3527 21.891 19.6895 22.0029 19.9144 22.0029C20.1394 22.0029 20.4762 21.891 20.7012 21.666C21.151 21.2161 21.151 20.5424 20.7012 20.0926ZM17.6673 18.6321C17.1055 19.1939 16.0938 19.1939 15.5321 18.6321C14.9703 18.0703 14.9703 17.0587 15.5321 16.4969C15.8689 16.272 16.2069 16.047 16.5437 16.047C16.9936 16.047 17.3304 16.16 17.6673 16.4969C17.8922 16.7218 18.0041 16.9468 18.0041 17.3955C18.1172 17.8454 17.8922 18.2942 17.6673 18.6321Z",
    fill: "#E025FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3645 2.00195C13.2199 2.00195 15.5336 4.31559 15.5336 7.17107C15.5336 10.0266 13.2199 12.3402 10.3645 12.3402C7.50895 12.3402 5.19531 10.0266 5.19531 7.17107C5.19531 4.31559 7.50895 2.00195 10.3645 2.00195Z",
    fill: "#E025FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24257 14.5879C7.66912 14.5879 6.20869 14.8128 5.08511 15.1497C4.4103 15.3746 3.7366 15.7115 3.28673 16.1613C2.83796 16.6101 2.5 17.2849 2.5 18.0716C2.5 18.8584 2.72494 19.4202 3.28673 19.9819C3.7366 20.4307 4.4103 20.7687 5.08511 20.9925C6.20869 21.3305 7.66912 21.5543 9.24257 21.5543C9.91739 21.5543 10.3662 21.1055 10.3662 20.4307V15.7115C10.3662 15.0378 9.91739 14.5879 9.24257 14.5879Z",
    fill: "#E025FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatching);
export default __webpack_public_path__ + "static/media/dispatching.7c264b9fe33526c28b845587f9d9a03c.svg";
export { ForwardRef as ReactComponent };